var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.96527H14.44C14.7497 1.96527 15 2.22836 15 2.554V8H13.74V7.04309H2.26V14.0343H8V15.3589H1.56C1.25025 15.3589 1 15.0958 1 14.7702V2.554C1 2.22836 1.25025 1.96527 1.56 1.96527H4.5V0.787808C4.5 0.706857 4.563 0.640625 4.64 0.640625H5.62C5.697 0.640625 5.76 0.706857 5.76 0.787808V1.96527H10.24V0.787808C10.24 0.706857 10.303 0.640625 10.38 0.640625H11.36C11.437 0.640625 11.5 0.706857 11.5 0.787808V1.96527Z",
    fill: "#142EA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2615 9.72133C13.2615 9.32272 12.9384 9 12.5404 9C12.1424 9 11.8193 9.32272 11.8193 9.72133V11.8191H9.72113C9.32309 11.8191 9 12.1418 9 12.5405C9 12.9391 9.32309 13.2618 9.72113 13.2618H11.8193V15.2787C11.8193 15.6773 12.1424 16 12.5404 16C12.9384 16 13.2615 15.6773 13.2615 15.2787V13.2618H15.2789C15.6769 13.2618 16 12.9391 16 12.5405C16 12.1418 15.6769 11.8191 15.2789 11.8191H13.2615V9.72133Z",
    fill: "#142EA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAppointment);
export default __webpack_public_path__ + "static/media/create_appointment.d22cce49600d8caea743505cf677005e.svg";
export { ForwardRef as ReactComponent };